import "./EventDetails.module.css";
import Header from "@/reusable_sections/Header";
import TheBrunchMenu from "./sections/TheBrunchMenu";
import TheCelebrationSchedule from "./sections/TheCelebrationSchedule";
import FindingTheVenue from "./sections/FindingTheVenue";
import Footer from "@/reusable_sections/Footer";
export default function EventDetailsPage() {
  return <div>
      <Header />
      <TheBrunchMenu />
      <TheCelebrationSchedule />
      <FindingTheVenue />
      <Footer />
    </div>;
}